import moment from 'moment/moment';
import { CreatePromotionModel } from 'domains/promotion/Promotion.types';
import { textFormatter } from 'utils';
import { getMomentDate, subtractDayFromMoment } from 'utils/date';
import { BannerPromotionPublicationTableData } from './PublishStep.types';

const getFormattedDate = (date: string | undefined) => textFormatter.formatDateShort(moment(date).toDate());

const getPublicationEnd = (endDate: string | undefined) =>
  getFormattedDate(subtractDayFromMoment(getMomentDate(endDate))?.toISOString());

const getBannerReferences = (promotion: CreatePromotionModel): string => {
  const uploadedReferencesFileName = promotion.uploadedReferencesFromFiles?.[0]?.fileName;

  if (uploadedReferencesFileName) {
    return uploadedReferencesFileName;
  }

  return promotion.references?.flatMap((section) => section.items.map((item) => item.item)).join(', ') ?? '';
};

export const getBannerPromotionsData = (promotion: CreatePromotionModel): BannerPromotionPublicationTableData => {
  const dealerListFileName = promotion.uploadedTargetedAudienceFromFile?.fileName ?? '';
  const dealerTypes = promotion.targetAudience.dealerTypes
    ? [...promotion.targetAudience.dealerTypes.map((dealer) => dealer.dealerType)]
        .sort((a, b) => a.localeCompare(b))
        .join(',')
    : '';
  return {
    key: promotion.promotionId,
    title: promotion.title ?? '',
    period: {
      publicationStart: promotion.publicationStart ? getFormattedDate(promotion.publicationStart) : '',
      publicationEnd: promotion.publicationEnd ? getPublicationEnd(promotion.publicationEnd) : '',
    },
    commercialFamilyCodes: promotion.commercialFamilyCodes
      ? promotion.commercialFamilyCodes[0].items.map((item) => item.item).join(', ')
      : '',
    referencesTimeLimited: getBannerReferences(promotion),
    targetedAudience: {
      dealerTypes: promotion.targetAudienceType === 'NETWORK' ? dealerTypes : '',
      fileName: promotion.targetAudienceType === 'DEALERS' ? dealerListFileName : '',
    },
  };
};
